<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="goToChallengeList()">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>{{ challengeInfo.name }}
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="groupList" :search="search" sort-by="member" sort-order="true" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options">
            <template slot="item" slot-scope="props">
                <tr>
                    <td>{{ props.item.name }}</td>
                    <td class="text-end pr-0">
                        {{ _formatData("number", props.item.weight) }}
                    </td>
                    <td class="text-start pl-0">
                        <v-icon v-if="!isNaN(props.item.weight) && props.item.weight > 0" color="red">mdi-arrow-up-thin</v-icon>
                        <v-icon v-else-if="!isNaN(props.item.weight) && props.item.weight < 0" color="green">mdi-arrow-down-thin</v-icon>
                    </td>
                    <td class="text-end pr-0">
                        {{ _formatData("number", props.item.BMI) }}
                    </td>
                    <td class="text-start pl-0">
                        <v-icon v-if="props.item.BMI < 0" color="green">mdi-arrow-down-thin</v-icon>
                        <v-icon v-else-if="props.item.BMI > 0" color="red">mdi-arrow-up-thin</v-icon>
                    </td>
                    <td class="text-end">{{ props.item.healthPoint }}</td>
                    <td>
                        <v-btn depressed color="info" class="mr-1" x-small @click="goToUserList(props.item)">Result</v-btn>
                        <!-- <v-btn v-if="!props.item.verify" depressed color="info" class="mr-1" x-small @click="goToGroupDetails(props.item)">Verify</v-btn> -->
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
    <br />
    <v-alert border="right" colored-border type="error" elevation="2">
        นับผลการแข่งเฉพาะคนที่มี bmi เริ่มต้น 25 ขึ้นไป
        <br />และส่งผลน้ำหนักจบการแข่งขันในไทยสุขเรียบร้อยแล้ว
    </v-alert>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getChallengeGroupList from "../data/getChallengeGroupList";
import getChallengeInfoById from "../data/getChallengeInfoById";

export default {
    name: 'ChallengeGroupList',
    metaInfo: {
        title: 'Challenge Group List'
    },
    data() {
        return {
            options: {
                itemsPerPage: 20,
            },
            search: "",
            headers: [{
                    text: "Group Name",
                    value: "name",
                },
                {
                    text: "Weight Diff",
                    value: "weight",
                    align: "end",
                    class: "pr-0",
                },
                {
                    text: "",
                    value: "weightTemplate",
                    align: "start",
                    class: "pl-0",
                    sortable: false,
                },
                {
                    text: "Average BMI Diff",
                    value: "BMI",
                    align: "end",
                    class: "pr-0",
                },
                {
                    text: "",
                    value: "BMITemplate",
                    align: "start",
                    class: "pl-0",
                    sortable: false,
                },
                {
                    text: "Total Healthpoint",
                    value: "healthPoint",
                    align: "end",
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                },
            ],
            groupList: [],
            challengeInfo: [],
            loading: false
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        //competition id
        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            // "loggedInUserName",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isChallengeAdmin) {
                (async () => {
                    this.loading = true;
                    this.challengeInfo = await getChallengeInfoById(this.id);
                    this.loading = false;
                })();

                (async () => {
                    this.loading = true;
                    this.groupList = await getChallengeGroupList(this.id);
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToChallengeList() {
            this.$router.push(`/challenge`);
        },
        goToUserList(item) {
            this.$router.push(`/challenge/${this.id}/${item.id}`);
        },
        goToGroupDetails(item) {
            this.$router.push(`/challenge/${this.id}/${item.id}/verify`)
        }
    },
};
</script>
